import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
//import Breadcrumbs
import { getProfiles,postFileProfile } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,ToastHelper} from '../../../helpers/alerts/alertHelper';
import avatar from "../../../assets/images/users/avatar-1.jpg";
import { useParams } from 'react-router-dom';
import ValidateFileHelper from '../../../helpers/ValidateFileHelper'
import { getStorageUser } from '../../../helpers/api_helper';
import {Container,Row,Col,Card,Alert,CardBody,Button,Label,Input,FormFeedback,Form} from "reactstrap";
import UpdatePassw from './updatePassw';
const Profile = () => {
    const authUser = getStorageUser();
    const [errors, setErrors] = useState({});
    const [image, setImage] = useState(false);
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState(false);
    const [file, setFile] = useState(null);
    const [user, setUser] = useState({
        name: '',
        email: '',
        profile_id: null,
        image:'',
        profile: {
            id: null,
            name: ''
        },
    });
    const {id} = useParams();

    useEffect(() => {
        getProfiles(id).then(response => {
            setUser(response.user)
        })
    }, [])

    const destroy = (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            deleteUser(id).then(response => {
                Alert(response.message,response.status)
                if (response.status) {
                    setItems(
                        items.filter(i => i.id != id)
                    );
                }           
            })
        });
    }
    const fileValidate = (file) => {
        setErrors({})
        const validate = ValidateFileHelper(file, {required: true, type: 'image', size: 1}, 'Imagen de perfil');
        if(validate != undefined){
            setErrors(validate);
            return;
        }
        setFile(file);
        setImage(true)
    }
    const fileUpload = () => {
        let auth = JSON.parse(localStorage.getItem("authUser"))
        setPending(true)
        postFileProfile(id,file).then(response => {
            Alert(response.message,response.status)
            if (response.status) {
                setUser(response.user)

                if (auth.user.id==response.user.id) {
                    auth.user.image=response.user.image
                    localStorage.setItem("authUser", JSON.stringify(auth))
                }
                setPending(false)
                setImage(false)
            }
        })
    }
    
    
    document.title = "Perfil de usuario";
    return (
        <React.Fragment>
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex">
                                    {user.profile_id==6 &&
                                        <div className="ms-10">
                                            <img
                                                src={user.image ? user.image:avatar}
                                                alt=""
                                                className="avatar-md rounded-circle img-thumbnail"
                                                style={{width:"82px",height:"82px",}}
                                            />
                                        </div>
                                    }
                                    
                                    <div className="flex-grow-1 align-self-center ms-3">
                                        <div className="text-muted">
                                            <h5>{user.name}</h5>
                                            <p className="mb-1">{user.email}</p>
                                            <p className="mb-0">Id no: #{user.id}</p>
                                            {(authUser.id == user.id) &&
                                                <>
                                                    <p className="mb-0">
                                                        Cambio de contraseña &nbsp;
                                                        <button className="btn btn-primary btn-sm" title='Editar Contraseña' onClick={() => setModal({show:true})}><i className="fas fa-edit"></i></button>
                                                    </p>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    {user.profile_id==6 &&
                                        <div className="ms-10">
                                        <img
                                            src={user.qr ? user.qr:avatar}
                                            alt=""
                                            className="avatar-md img-thumbnail"
                                            style={{width:"100px",height:"100px",}}
                                        />
                                    </div>
                                    }
                                </div>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <h4 className="card-title mb-4">Información </h4>
                <Card>
                    <CardBody>
                        <div className="row">
                            <div className="col-sm-2">
                                <p className="mb-1">Nombre de Empresa</p>   
                                <h5>{user.company_name}</h5>
                            </div>
                            <div className="col-sm-2">
                                <p className="mb-1">Nombre de Perfil</p>   
                                <h5>{user.profile_name}</h5>
                            </div>
                            <div className="col-sm-8">
                                <p className="mb-2">Cuenta verificada</p>
                                <h5>{user.verified}</h5>
                            </div>

                            {user.profile_id==6 &&
                                    <>
                                    <div className="col-sm-2">
                                        <p className="mb-2">Clave</p>    
                                        <h5>{user.operator.key}</h5>
                                    </div>
                                    <div className="col-sm-2">
                                        <p className="mb-2">Ruta</p>    
                                        <h5>{user.operator.route_name}</h5>
                                    </div>
                                    <div className="col-sm-2">
                                        <p className="mb-2">Numero de unidad</p>    
                                        <h5>{user.operator.unitNo}</h5>
                                    </div>
                                    </>
                                }
                        </div>
                    </CardBody>
                </Card>
            </Container>
            {modal.show &&
                <UpdatePassw 
                    modal={modal}
                    setModal={setModal}
                />
            }
        </div>
    </React.Fragment>
    );
};

export default Profile;
